import {
  NOT_CONFIRMED
} from '@lba-dev/package.local-globals/permissions';

import componentLoader from '../../componentLoader';

const ListIntervention = componentLoader(() =>
  import(
    /* webpackChunkName: "ListInterventionQuality" */
    '../../views/List/ListIntervention'
  )
);

const ListReviews = componentLoader(() =>
  import(
    /* webpackChunkName: "ListReviewsQuality" */
    '../../views/Quality/ListReviews'
  )
);

export default [
  {
    path: '/quality/list/:filter/:query',
    component: ListIntervention,
    restrictions: () => NOT_CONFIRMED,
  },
  {
    path: '/quality/list/:filter',
    component: ListIntervention,
    restrictions: () => NOT_CONFIRMED,
  },
  {
    path: '/reviews/list/:filter',
    component: ListReviews,
    restrictions: () => NOT_CONFIRMED,
  },
  {
    path: '/reviews/list',
    component: ListReviews,
    restrictions: () => NOT_CONFIRMED,
  },
];
